import { render, staticRenderFns } from "./change_prefix.vue?vue&type=template&id=21f953bb&"
import script from "./change_prefix.vue?vue&type=script&lang=js&"
export * from "./change_prefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports